import styled, { css } from "styled-components";

export const Badge = styled.span(
  ({ theme: { colors } }) => css`
    padding: 0.35rem 0.63rem;
    border: 0.063rem solid ${colors.white};
    font-size: 0.9rem;
  `
);
